import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';

import AffectedUrlsExport from './AffectedUrlsExport';
import { useGetDetectorCatalogQuery } from './detectorCatalogApi';
import { isDiagnosticsFeatureEnabled } from './featureSwitch';
import IncidentActions from './IncidentActions';
import IncidentDetailsView from './IncidentDetailsView';
import { useGetIncidentQuery } from './incidentsApi';
import { loadableOf } from './loadable';
import { wasOpenedFromTriage } from './routes';

function IncidentDetails(): JSX.Element {
  const now = new Date();
  const enabled = isDiagnosticsFeatureEnabled();
  const { reference = '' } = useParams<{ reference: string }>();
  const incident = useGetIncidentQuery(reference, { skip: !enabled });
  const catalog = useGetDetectorCatalogQuery(undefined, { skip: !enabled });
  const navigate = useNavigate();
  const returnToTriage = wasOpenedFromTriage(useLocation().state) ? () => navigate(-1) : undefined;

  if (!enabled) {
    return <Navigate to="/users" replace />;
  }

  return (
    <IncidentDetailsView
      reference={reference}
      onBackToTriage={returnToTriage}
      incident={loadableOf(incident)}
      catalog={loadableOf(catalog)}
      now={now}
      actions={(detail) => <IncidentActions incident={detail} />}
      affectedUrlsExport={<AffectedUrlsExport reference={reference} />}
    />
  );
}

export default IncidentDetails;
